var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "row col-12 col-md-8 d-flex justify-content-center justify-content-md-start pl-md-0 mt-3 mt-md-0 styled-scrollbar-custom pr-under-md-0 pl-under-md-0",
      attrs: { id: "annonce-create-step-right-part" }
    },
    [
      _c(
        "div",
        {
          staticClass: "w-100",
          attrs: { id: "annonce-create-step-right-part-inside" }
        },
        [
          _vm.isLicensedAndNeedPlate
            ? _c(
                "div",
                { staticClass: "col-12 pl-0 pr-0 mb-1" },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "small-text",
                      attrs: {
                        label: _vm.$t("annonce.vehicle.Plate") + "*",
                        "invalid-feedback": _vm.licensePlate.invalidFeedback,
                        "label-for": "licensePlate-input"
                      }
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          state: _vm.licensePlate.state,
                          id: "licensePlate-input",
                          formatter: _vm.IdentifierUtils.formatLicensePlate,
                          required: ""
                        },
                        on: {
                          change: function($event) {
                            _vm.setAnnonce
                            _vm.updateFeedbackLicensePlate()
                          }
                        },
                        model: {
                          value: _vm.licensePlate.value,
                          callback: function($$v) {
                            _vm.$set(_vm.licensePlate, "value", $$v)
                          },
                          expression: "licensePlate.value"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      staticClass: "small-text",
                      attrs: {
                        label: _vm.$t("annonce.vehicle.Plate.confirm") + "*",
                        "invalid-feedback":
                          _vm.licensePlateConfirm.invalidFeedback,
                        "label-for": "licensePlateConfirm-input"
                      }
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          state: _vm.licensePlateConfirm.state,
                          id: "licensePlateConfirm-input",
                          formatter: _vm.IdentifierUtils.formatLicensePlate,
                          required: ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.updateFeedbackLicensePlateConfirm()
                          }
                        },
                        model: {
                          value: _vm.licensePlateConfirm.value,
                          callback: function($$v) {
                            _vm.$set(_vm.licensePlateConfirm, "value", $$v)
                          },
                          expression: "licensePlateConfirm.value"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm.isNotLicensedAndNeedVIN
            ? _c(
                "div",
                { staticClass: "col-12 pl-0 pr-0 mb-1" },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "small-text",
                      attrs: {
                        label: _vm.$t("annonce.vehicle.vin") + "*",
                        "invalid-feedback": _vm.vin.invalidFeedback,
                        "label-for": "vin-input"
                      }
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          state: _vm.vin.state,
                          id: "vin-input",
                          formatter: _vm.IdentifierUtils.formatVin,
                          required: !_vm.serialNumber.value
                        },
                        on: {
                          change: function($event) {
                            _vm.setAnnonce
                            _vm.updateFeedbackVin()
                          }
                        },
                        model: {
                          value: _vm.vin.value,
                          callback: function($$v) {
                            _vm.$set(_vm.vin, "value", $$v)
                          },
                          expression: "vin.value"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm.isNotLicensedAndNeedBicycode
            ? _c(
                "div",
                { staticClass: "col-12 pl-0 pr-0 mb-1" },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "small-text",
                      attrs: {
                        label: _vm.$t("annonce.vehicle.bicycode") + "*",
                        "invalid-feedback": _vm.bicycode.invalidFeedback,
                        "label-for": "bicycode-input"
                      }
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          state: _vm.bicycode.state,
                          id: "bicycode-input",
                          required: !_vm.serialNumber.value,
                          formatter: _vm.IdentifierUtils.formatBicycode
                        },
                        on: {
                          change: function($event) {
                            _vm.setAnnonce
                            _vm.updateFeedbackBicycode()
                          }
                        },
                        model: {
                          value: _vm.bicycode.value,
                          callback: function($$v) {
                            _vm.$set(_vm.bicycode, "value", $$v)
                          },
                          expression: "bicycode.value"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isNotLicensedAndNeedSerialNumberPlusAnother
            ? _c(
                "div",
                { staticClass: "col-12 pl-0 pr-0 mb-2 choice-id-vehicule" },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("annonce.vehicle.bicycode.and.or.serialNumber")
                    )
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isNotLicensedAndNeedSerialNumber
            ? _c(
                "div",
                { staticClass: "col-12 pl-0 pr-0 mb-1" },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "small-text",
                      attrs: {
                        label: _vm.$t("annonce.vehicle.serialNumber") + "*",
                        "invalid-feedback": _vm.serialNumber.invalidFeedback,
                        "label-for": "serialNumber-input"
                      }
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          state: _vm.serialNumber.state,
                          id: "serialNumber-input",
                          required: !_vm.bicycode.value && !_vm.vin.value
                        },
                        on: {
                          change: function($event) {
                            _vm.setAnnonce
                            _vm.removeInvalidFeedback("serialNumber")
                          }
                        },
                        model: {
                          value: _vm.serialNumber.value,
                          callback: function($$v) {
                            _vm.$set(_vm.serialNumber, "value", $$v)
                          },
                          expression: "serialNumber.value"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 pl-0 pr-0 mb-1" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "small-text",
                  attrs: {
                    label: _vm.$t("annonce.vehicle.Color") + "*",
                    "label-for": "color-input",
                    "invalid-feedback": _vm.color.invalidFeedback,
                    state: _vm.color.state
                  }
                },
                [
                  _c(
                    "b-form-select",
                    {
                      attrs: {
                        id: "color-input",
                        state: _vm.color.state,
                        required: ""
                      },
                      on: {
                        change: function($event) {
                          _vm.setAnnonce
                          _vm.removeInvalidFeedback("color")
                        }
                      },
                      model: {
                        value: _vm.color.value,
                        callback: function($$v) {
                          _vm.$set(_vm.color, "value", $$v)
                        },
                        expression: "color.value"
                      }
                    },
                    _vm._l(_vm.colors, function(color) {
                      return _c(
                        "option",
                        { domProps: { value: color.value } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t(color.text)) +
                              "\n          "
                          )
                        ]
                      )
                    }),
                    0
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 pl-0 pr-0 mb-1" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "small-text",
                  attrs: {
                    label: _vm.$t("annonce.vehicle.Energy") + "*",
                    "label-for": "energy-input",
                    "invalid-feedback": _vm.energy.invalidFeedback,
                    state: _vm.energy.state
                  }
                },
                [
                  _c(
                    "b-form-select",
                    {
                      attrs: {
                        id: "energy-input",
                        state: _vm.energy.state,
                        required: ""
                      },
                      on: {
                        change: function($event) {
                          _vm.setAnnonce
                          _vm.removeInvalidFeedback("energy")
                        }
                      },
                      model: {
                        value: _vm.energy.value,
                        callback: function($$v) {
                          _vm.$set(_vm.energy, "value", $$v)
                        },
                        expression: "energy.value"
                      }
                    },
                    _vm._l(_vm.energies, function(energy) {
                      return _c(
                        "option",
                        { domProps: { value: energy.value } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t(energy.text)) +
                              "\n          "
                          )
                        ]
                      )
                    }),
                    0
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 pl-0 pr-0 mb-1" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "small-text",
                  attrs: {
                    label: _vm.$t("annonce.place.robbery") + "*",
                    "label-for": "address-input",
                    "invalid-feedback": _vm.address.invalidFeedback,
                    state: _vm.address.state
                  }
                },
                [
                  _c(
                    "b-input-group",
                    [
                      _c("GmapAutocomplete", {
                        ref: "addressAutocomplete",
                        staticClass: "form-control",
                        attrs: {
                          id: "address-input",
                          required: "",
                          options: _vm.autocompleteOptions
                        },
                        on: {
                          change: function($event) {
                            return _vm.removeInvalidFeedback("address")
                          },
                          input: _vm.handleStartAddressInput,
                          place_changed: _vm.handleAddressSelect
                        },
                        model: {
                          value: _vm.address.value,
                          callback: function($$v) {
                            _vm.$set(_vm.address, "value", $$v)
                          },
                          expression: "address.value"
                        }
                      }),
                      _vm._v(" "),
                      _c("b-input-group-append", [
                        _c(
                          "div",
                          {
                            class:
                              _vm.locationPermission === "granted"
                                ? "custom-append-locate cursor-pointer"
                                : "custom-append-locate-disabled",
                            attrs: { id: "pin-locate" },
                            on: { click: _vm.locateUser }
                          },
                          [
                            _c("i", {
                              staticClass: "ph-custom ph-map-pin",
                              class:
                                _vm.locationPermission === "granted"
                                  ? "main-color"
                                  : "text-disabled"
                            })
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _vm.locationPermission !== "granted"
                        ? _c(
                            "b-tooltip",
                            {
                              attrs: {
                                target: "pin-locate",
                                placement: "bottom",
                                triggers: "hover"
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("autorisation.geolocation.tooltip")
                                  ) +
                                  "\n          "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 pl-0 pr-0 mb-1" },
            [
              _c("b-form-group", {
                attrs: {
                  "invalid-feedback": _vm.isProprio.invalidFeedback,
                  state: _vm.isProprio.state
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var ariaDescribedby = ref.ariaDescribedby
                      return [
                        _c(
                          "b-form-radio",
                          {
                            staticClass: "mb-2 mt-2 radio-proprio",
                            attrs: { value: true },
                            on: {
                              change: function($event) {
                                _vm.setAnnonce
                                _vm.removeInvalidFeedback("isProprio")
                              }
                            },
                            model: {
                              value: _vm.isProprio.value,
                              callback: function($$v) {
                                _vm.$set(_vm.isProprio, "value", $$v)
                              },
                              expression: "isProprio.value"
                            }
                          },
                          [
                            _c("span", { staticClass: "ml-2" }, [
                              _vm._v(_vm._s(_vm.$t("annonce.is.prorio")))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass:
                              "small-text main-grey-medium-color mb-3"
                          },
                          [_vm._v(_vm._s(_vm.$t("annonce.leasing")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-radio",
                          {
                            staticClass: "radio-proprio",
                            attrs: { value: false },
                            model: {
                              value: _vm.isProprio.value,
                              callback: function($$v) {
                                _vm.$set(_vm.isProprio, "value", $$v)
                              },
                              expression: "isProprio.value"
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "ml-2",
                                on: {
                                  change: function($event) {
                                    _vm.setAnnonce
                                    _vm.removeInvalidFeedback("isProprio")
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("annonce.not.prorio")))]
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "row" }, [
              _vm.isProprio.value === false
                ? _c(
                    "div",
                    { staticClass: "col-6 pl-0 mb-1" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "small-text",
                          attrs: {
                            label: _vm.$t("annonce.lastnameOwner"),
                            "label-for": "lastnameOwner-input",
                            "invalid-feedback":
                              _vm.lastnameOwner.invalidFeedback
                          }
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "lastnameOwner-input",
                              state: _vm.lastnameOwner.state,
                              required: ""
                            },
                            on: {
                              input: function($event) {
                                _vm.setAnnonce
                                _vm.removeInvalidFeedback("lastnameOwner")
                              }
                            },
                            model: {
                              value: _vm.lastnameOwner.value,
                              callback: function($$v) {
                                _vm.$set(_vm.lastnameOwner, "value", $$v)
                              },
                              expression: "lastnameOwner.value"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isProprio.value === false
                ? _c(
                    "div",
                    { staticClass: "col-6 pr-0 mb-1" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "small-text",
                          attrs: {
                            label: _vm.$t("annonce.firstnameOwner"),
                            "label-for": "firstnameOwner-input",
                            "invalid-feedback":
                              _vm.firstnameOwner.invalidFeedback
                          }
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "firstnameOwner-input",
                              state: _vm.firstnameOwner.state,
                              required: ""
                            },
                            on: {
                              input: function($event) {
                                _vm.setAnnonce
                                _vm.removeInvalidFeedback("firstnameOwner")
                              }
                            },
                            model: {
                              value: _vm.firstnameOwner.value,
                              callback: function($$v) {
                                _vm.$set(_vm.firstnameOwner, "value", $$v)
                              },
                              expression: "firstnameOwner.value"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _vm.isProprio.value === false
            ? _c(
                "div",
                { staticClass: "col-12 pl-0 pr-0 mb-1" },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "small-text",
                      attrs: {
                        label: _vm.$t("identityRectoFile"),
                        "label-for": "recto-input",
                        "invalid-feedback": _vm.identityRecto.invalidFeedback,
                        state: _vm.identityRecto.state
                      }
                    },
                    [
                      _c("b-form-file", {
                        attrs: {
                          id: "recto-input",
                          "browse-text": _vm.$t("Select"),
                          placeholder: _vm.identityRecto.fileName,
                          required: "",
                          accept: ".png, .jpeg, .jpg, .pdf"
                        },
                        on: {
                          input: function($event) {
                            _vm.setAnnonce($event)
                            _vm.removeInvalidFeedback("identityRecto")
                          }
                        },
                        model: {
                          value: _vm.identityRecto.value,
                          callback: function($$v) {
                            _vm.$set(_vm.identityRecto, "value", $$v)
                          },
                          expression: "identityRecto.value"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isProprio.value === false
            ? _c(
                "div",
                { staticClass: "col-12 pl-0 pr-0 mb-1" },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "small-text",
                      attrs: {
                        label: _vm.$t("identityVersoFile"),
                        "label-for": "verso-input",
                        "invalid-feedback": _vm.identityVerso.invalidFeedback,
                        state: _vm.identityVerso.state
                      }
                    },
                    [
                      _c("b-form-file", {
                        attrs: {
                          id: "verso-input",
                          "browse-text": _vm.$t("Select"),
                          placeholder: _vm.identityVerso.fileName,
                          required: "",
                          accept: ".png, .jpeg, .jpg, .pdf"
                        },
                        on: {
                          input: function($event) {
                            _vm.setAnnonce($event)
                            _vm.removeInvalidFeedback("identityVerso")
                          }
                        },
                        model: {
                          value: _vm.identityVerso.value,
                          callback: function($$v) {
                            _vm.$set(_vm.identityVerso, "value", $$v)
                          },
                          expression: "identityVerso.value"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-643fbb22", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-643fbb22","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/annonce/AnnonceCreate/AnnonceCreateStep4.vue
// module id = pfEf
// module chunks = 0